<template lang="pug">
div
  h1 New Issue

  IssueForm
</template>

<script>
  import { mapStores } from 'pinia'
  import { useIssueStore } from '@/stores/issue'

  import IssueForm from '../shared/form.vue'

  export default {
    components: {
      IssueForm
    },

    computed: {
      ...mapStores(useIssueStore)
    },

    async mounted() {
      await this.issueStore.$reset()
    }
  }
</script>
